module.exports = "/img/32.5f334e.webp";